import cx from 'classnames'
import { Language } from '~/utils/language'
import styles from './LanguageTab.module.css'

type LanguageSetting = {
  language: Language
  name: string
}

type LanguageTabProps = {
  className?: string
  languageSettingList: LanguageSetting[]
  currentLanguage: Language
  onChange: (nextLanguage: Language) => void
}

function LanguageTab(props: LanguageTabProps) {
  const { className, languageSettingList, currentLanguage, onChange } = props
  return (
    <div className={cx(styles.root, className)}>
      {languageSettingList.map((setting) => (
        <button
          key={setting.language}
          className={cx(styles.button, {
            [styles.currentButton]: setting.language === currentLanguage,
          })}
          onClick={() => {
            onChange(setting.language)
          }}
        >
          {setting.name}
        </button>
      ))}
    </div>
  )
}

export default LanguageTab
